import React from "react";
import { useSelector } from 'react-redux';

function Contact() {
   const eventData = useSelector((state) => state.event.eventData);
        const contact = eventData.people|| [];
        const backgroundImage = eventData.people.imageKey;
  return (
    <div
      class="contact-area3 bg-top-center  overflow-hidden"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div class="container">
        <div class="row gy-4 justify-content-between align-items-center">
          <div class="col-lg-5">
            <div class="pt-80 p-lg-0">
              <div class="title-area pe-xl-5">
                <span class="sub-title text-white">{contact.Heading}</span>
                <h2 class="sec-title text-white">{contact.subHeading}</h2>
                <p class="contact-text text-white">
                 {contact.paragraph}
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="contact-form-area">
              <form
                action="mail.php"
                method="POST"
                class="contact-form2 ajax-contact"
              >
                <div class="row">
                  <div class="form-group col-12">
                    <input
                      type="text"
                      class="form-control"
                      name="name"
                      id="name3"
                      placeholder="First Name"
                    />
                    <img src="assets/img/icon/user.svg" alt="" />
                  </div>
                  <div class="form-group col-12">
                    <input
                      type="email"
                      class="form-control"
                      name="email3"
                      id="email3"
                      placeholder="Your Mail"
                    />
                    <img src="assets/img/icon/mail.svg" alt="" />
                  </div>
                
                  <div class="form-group col-12">
                    <textarea
                      name="message"
                      id="message"
                      cols="30"
                      rows="3"
                      class="form-control"
                      placeholder="Your Message"
                    ></textarea>
                    <img src="assets/img/icon/chat.svg" alt="" />
                  </div>
                </div>
                <p class="form-messages mb-0 mt-3"></p>
              </form>
              <div class="form-btn-wrapp">
                <div class="form-btn">
                  <button class="th-btn white-btn">
                    Send Message <img src="assets/img/icon/plane3.svg" alt="" />
                  </button>
                </div>
                <div class="contact-info">
                  <p class="contact-info_link">
                    <a href="tel:+0123456789">{contact.title}</a>
                  </p>
                  <div class="contact-info_icon">
                    <a href="tel:+0123456789">
                      <img src="assets/img/icon/call.svg" alt="" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
